import { Text } from '@chakra-ui/react';

export default function ProductDesc({ desc = '', startHeight = 40 }) {
    // const [show, setShow] = useState(false);

    // const handleToggle = () => setShow(!show);

    // useEffect(() => {
    //     if (desc.length > 100) {
    //         setShow(true);
    //     }
    // }, [desc]);

    return (
        <>
            <Text fontSize='md' lineHeight={1.3} textOverflow='ellipsis' whiteSpace='pre-line'>
                {desc}
            </Text>
            {/* <Collapse startingHeight={startHeight} in={true}>
                <Text fontSize='md' lineHeight={1.3} textOverflow='ellipsis' whiteSpace='pre-line'>
                    {desc}
                </Text>
            </Collapse>
            <Button variant='unstyled' size='sm' onClick={handleToggle} color='gray.500' fontWeight={500} _hover={{ color: 'gray.800' }}>
                Show {show ? 'Less' : 'More'}
            </Button> */}
        </>
    );
}
